function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
export const logBodyPadding = 16;
export const styles = {
  container: process.env.NODE_ENV === "production" ? {
    name: "1kpbo3t",
    styles: "width:100%;background-color:var(--theme-colors-background-default);font-family:monospace;color:var(--theme-colors-text-primary);display:flex;flex-direction:column;overflow:hidden;max-width:100%;height:100%"
  } : {
    name: "1vonfn6-container",
    styles: "width:100%;background-color:var(--theme-colors-background-default);font-family:monospace;color:var(--theme-colors-text-primary);display:flex;flex-direction:column;overflow:hidden;max-width:100%;height:100%;label:container;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  header: process.env.NODE_ENV === "production" ? {
    name: "1psiagc",
    styles: "padding-bottom:0.75rem;border-bottom:1px solid #e0e0e0;display:flex;justify-content:space-between;align-items:center"
  } : {
    name: "18rgcur-header",
    styles: "padding-bottom:0.75rem;border-bottom:1px solid #e0e0e0;display:flex;justify-content:space-between;align-items:center;label:header;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  logsContainer: process.env.NODE_ENV === "production" ? {
    name: "fwn7c2",
    styles: "background-color:#1e1e1e;color:#d4d4d4;font-size:14px;line-height:1.6;height:calc(100vh - 300px);border-radius:0 0 8px 8px"
  } : {
    name: "18ix556-logsContainer",
    styles: "background-color:#1e1e1e;color:#d4d4d4;font-size:14px;line-height:1.6;height:calc(100vh - 300px);border-radius:0 0 8px 8px;label:logsContainer;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  logsBody: process.env.NODE_ENV === "production" ? {
    name: "7bra7c",
    styles: "overflow-y:auto;white-space:pre"
  } : {
    name: "1f91bmu-logsBody",
    styles: "overflow-y:auto;white-space:pre;label:logsBody;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  logLine: /*#__PURE__*/css({
    display: 'flex',
    paddingLeft: logBodyPadding,
    paddingRight: logBodyPadding,
    paddingTop: '0',
    paddingBottom: '0'
  }, process.env.NODE_ENV === "production" ? "" : ";label:logLine;"),
  tailButton: process.env.NODE_ENV === "production" ? {
    name: "19v8wf3",
    styles: "background:transparent;border:1px solid #ccc;border-radius:4px;padding:0.25rem 0.5rem;font-size:12px;cursor:pointer;color:var(--theme-colors-text-primary);:hover{background:rgba(255,255,255,0.1);}"
  } : {
    name: "kumiy9-tailButton",
    styles: "background:transparent;border:1px solid #ccc;border-radius:4px;padding:0.25rem 0.5rem;font-size:12px;cursor:pointer;color:var(--theme-colors-text-primary);:hover{background:rgba(255,255,255,0.1);};label:tailButton;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};